<template>
	<Detail v-bind="$props">
		<slot />
	</Detail>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import Detail from '#base/app/components/template/Detail.vue';
import type { ButtonType } from '#base/core/types/ButtonType';

defineProps<{
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	title: string;
	description: string;
	button?: ButtonType;
}>();
</script>
